<template>
   <div class="related-products--wrapper">
        
		 <b-row >
            <b-col class="text-left">
                <div class="py-2 section-title text-left">{{heading}}</div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div ref="rpswiper" v-swiper:mySwiper="swiperOption" class="px-0">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" :key="product.id" v-for="product in products">
							<div class="related-product--card">
							
							  <div class="related-product--img-wrapper img-container imgcatOrg"> 
							  
								<b-link v-if="product.product_slug==null" :href="'/product/'+product.product_id">
									<b-img v-if="product.image=='' || product.image==null" :src="$root.MEDIAPATH+'blank.jpg'" fluid></b-img>
								   
									<!--<b-img v-else :src="product.image.replace('_rg','_th')" :data-src="product.image.replace('_rg','_th')" fluid class="swiper-lazy"></b-img>-->
									
									<b-img v-else :src="$root.MEDIAAPI+'toolimage/get_image?size=210x185&src='+product.image" :alt="product.title" class="related-product--img d-block"></b-img>
								</b-link>
								<b-link v-else :href="'/'+product.product_slug">
									<b-img v-if="product.image=='' || product.image==null" :src="$root.MEDIAPATH+'blank.jpg'" fluid></b-img>
								   
									<!--<b-img v-else :src="product.image.replace('_rg','_th')" :data-src="product.image.replace('_rg','_th')" fluid class="swiper-lazy"></b-img>-->
									
									<b-img v-else :src="$root.MEDIAAPI+'toolimage/get_image?size=210x185&src='+product.image" :alt="product.title" class="related-product--img d-block"></b-img>
								</b-link>
								   
								</div>
								
								<productimage-slider v-if="product.product_slug==null"   :galleryimages="JSON.parse(product.gallery_images)" phoneImageWidth="210" phoneImageHeight="185" :product_slug="'/product/'+product.product_id" class="d-none d-md-block" ></productimage-slider>
								<productimage-slider v-else :galleryimages="JSON.parse(product.gallery_images)" phoneImageWidth="210" phoneImageHeight="185" :product_slug="'/'+product.product_slug" class="d-none d-md-block" ></productimage-slider>
								
								
							
								<div class="w-100 addtoCartbtn">
								   <b-button v-if="product.product_type==2 && product.product_slug==null" type="button" squared variant="outline-secondary" class="related-product--add-cart-cta d-block" :href="'/product/'+product.product_id" >View Product</b-button> 
								   <b-button v-if="product.product_type==2 && product.product_slug!=null" type="button" squared variant="outline-secondary" class="related-product--add-cart-cta d-block" :href="'/'+product.product_slug" >View Product</b-button> 
								   
								   
								  <b-button v-if="product.product_type==1 && product.stock_qty > 0" type="button"  squared variant="outline-secondary" class="related-product--add-cart-cta " @click="$root.updateCart(product,1)">Add to Bag</b-button>
								  
								  <b-button v-if="product.product_type==1 && product.stock_qty == 0 && product.product_slug==null" type="button"  squared variant="outline-secondary" class="related-product--add-cart-cta " :href="'/product/'+product.product_id" >Sold Out</b-button>
								  <b-button v-if="product.product_type==1 && product.stock_qty == 0 && product.product_slug!=null" type="button"  squared variant="outline-secondary" class="related-product--add-cart-cta " :href="'/'+product.product_slug" >Sold Out</b-button>
								  </div>

								
								<div class="pl-2 pr-2 w-100 ptitleDetail">
									<h4  class="text-truncate"><b-link :href="'/brand/'+product.brand.replace(/ /g,'-')" >{{product.brand}}</b-link></h4>
									<h5 class="text-truncate">
									<b-link v-if="product.product_slug==null" :href="'/product/'+product.product_id" >{{product.title}}</b-link>
									<b-link  v-else :href="'/'+product.product_slug" >{{product.title}}</b-link>
									
									</h5>
								</div>
								
							<!--
							<b-link :href="'/product/'+product.product_id" class="swipper-title">{{product.brand}}</b-link>
							<p class=" text-truncate ">
							<b-link :href="'/product/'+product.product_id" class="swipper-title">{{product.title}}</b-link>
							</p> -->
								
								 <div class="related-product--price-info-wrapper">
									<div class="swiper-priceinfo" v-if="product.special_price>0 && product.special_price!=null">
										<b>{{$root.currency()+$root.tofixed(product.special_price, 2)}}</b>   <small>M.R.P. <del>{{$root.currency()+$root.tofixed(product.price, 2)}} </del> <span style="margin-left:5%;color:#7954a1;">({{$root.tofixed((product.price - product.special_price)*100/product.price, 0)}}% off)</span></small>
										
									</div>
									<div class="swiper-priceinfo" v-else>
										<b>{{$root.currency()+$root.tofixed(product.price, 2)}}</b>                                
									</div>
								</div>
								
								  
								  
								  <!--<addtocart-button :productData="modaldata" :productview="true" :cartQty="modaldata_qty" ></addtocart-button> -->
								<!--<div class="swiper-lazy-preloader"></div>-->
								
							</div>
                        </div>
                    </div>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev" @click="mySwiper.slidePrev()"></div>
                    <div class="swiper-button-next" slot="button-next" @click="mySwiper.slideNext()"></div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
//import AddtocartButton from "@/components/addtocartButton.vue";
import ProductimageSlider from "@/components/productimageSlider.vue";
export default {
  name: 'Quickview',
  props: {
    products: { type: Array },
    showQuickViewListener: { type: Function },
    heading: String
  },
  components: {
  //"addtocart-button": AddtocartButton,
  "productimage-slider": ProductimageSlider,
  },
  mounted(){
    //this.heading = "Related Products";
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  data() {
    return{
        swiperOption: {
            direction: 'horizontal',
            initialSlide: 0,
            slidesPerGroup: 2,
            loop: false,
            watchSlidesVisibility: true,
            /*preloadImages: false,
            lazy: true,*/
            loopFillGroupWithBlank: true,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 4,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                960: {
                    slidesPerView: 5,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                1124: {
                    slidesPerView: 5,
                    spaceBetween: 10
                }
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            on: {
                init: function () {
                    console.log('swiper initialized');
                },
                slideChange: function() {
                    console.log('slide changed');
                }
            },
            fadeEffect: {
                crossFade: true
            },
        }
    }
  },
  methods:{
    showQuickView(item){
        this.showQuickViewListener(item);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$whiteColor: #ffffff;
$blackColor: #000000; 
$borderLightColor: #d7d7d7;
$orangeColor: #fed83d; 
$themeColor: #8100d3;
$themeColor2: #8507d6;
$themeColor3: #b24bf1;
$themeColor4: #b554f2;
$lightGreyColor: #ababab;
$productCardBorderColor: #ededed;
$grey2Color: #a7a7a7;
$redColor: #ec3f79;
	.related-products {
	  &--wrapper {
		/*margin-top: 100px;*/
		background: #f9f9f9;
		padding: 27px 0 0px;

		.related-product {
		  &--card {
			/*max-width: 280px;
			min-height: 368px;
			 padding: 30px 0 0;*/
			display: flex;
		   
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			/*background-color: $whiteColor;
			 box-shadow: 0px 8px 9px 0px rgba(11, 0, 11, 0.1); */
			align-items: left;
			
				.ptitleDetail{
					min-height:34px;
					width:100%;
					h4{font-size: 14px;margin-bottom:1px;}
					h5{font-size: 13px;margin-bottom:1px;
						
						a{ color:#2c3e50;
						}
					}
				
				}  
		  }

		  &--title {
			font-size: 14px;
			font-weight: bold;
		  }

		  &--img-wrapper {
			/*min-height: 350px;*/
			display: flex;
			flex-direction: column;
			justify-content: center;

			img {
			  width: 100%;
			}
		  }

		  &--price-info-wrapper {
			margin-bottom: 5px;
			width:100%;
		    padding-left:8px;
			.actual-price-wrapper {
			  padding-right: 10px;
			  border-right: 1px solid #eeeeee;

			  .old-price {
				color: #93949b;
				text-decoration: line-through;
			  }

			  .actual-price {
				color: $blackColor;
				font-weight: bold;
			  }
			  
			  
			}
		  }

		  &--discount-wrapper {
			padding-left: 10px;

			.discount-txt {
			  color: $redColor;
			  font-weight: bold;
			}
		  }

		  &--add-cart-cta {
			width: 90%;
			/* min-height: 44px; */
			border-radius: 0;
			border: none;
			/* background-color: $themeColor3;*/
			text-transform: uppercase;
			color:$themeColor2 ;
			border: 1px solid $themeColor2;
			font-weight: 600;
			
			position:absolute;
			background:#fff;
			visibility:hidden;
			margin-left:5%;
			margin-top:-16px;
			height: 33px;
			font-size: 14px;

			&:hover {
			  background-color: $themeColor2;
			  color:#fff;
			}
		  }

		  &--carousel-indicators {
			margin-top: 55px;

			a {
			  .b-icon {
				width: 24px;
				height: 24px;
			  }

			  &:hover {
				.b-icon {
				  fill: red;
				}
			  }
			}
		  }
		}
		
		.imgcatOrg{
			visibility: visible;
		}
			.categorieslist{
					position:absolute;
					visibility: hidden;
					/*min-height: 250px;
					display: flex;
					flex-direction: column;
					justify-content: center;
					margin-bottom: 5px; */
					img{
					height: 254px;
					
					}
					
					
					
				}
		
		.section-title {
			font-size: 20px;
			/* &:after {
				position: absolute;
				height: 5px;
				width: 70px;
				background-color: #8100d3;
				content: "";
				left: 0;
				right: 0;
				margin: 0 auto;
				bottom: 0;
			} */
		}
		
		
		  .swiper-button-prev {
		  top: 40%;
		  width:25px;
		  height:25px;
		  left:18px;
		  
		  }
		  
		  .swiper-button-next{
		  top: 40%;
		  width:25px;
		  height:25px;
		  right: 18px;
		  
		
		  }
		  
		   .swiper-button-next:after, .swiper-button-prev:after {
				font-size: 16px;
				
			}
		  
		  .swiper-wrapper .swiper-slide{
			/*border: 1px solid #a585bc;*/
			padding: 0px;
			 background-color: #f9f9f9;
			
			&:hover {
				background-color: #fff;
				.related-product--add-cart-cta{
					visibility:visible;
				}
				.categorieslist{
					visibility: visible;
				}
				.imgcatOrg{
					visibility: hidden;
				}
				
			  }
		  }
		  
		  
		  .swiper-priceinfo{
			
				min-height: 26px;
				font-size:15px;
				text-align:left;
			  
			}
		  
		  .img-container{
			height:185px;
		 }
		
		  
	  }

	  &--txt {
		font-size: 48px;
		color: $blackColor;
		margin-bottom: 60px;
	  }
	  
	  
	  
	  
	  
	}
	
	

</style>
